<template>
  <div class="sharkbet-register">
    <div id="registerModalToggle" class="modal fade sharkbet-register__modal" aria-hidden="true"
      aria-labelledby="sharkbetRegisterTitle" tabindex="-1" data-bs-backdrop="false">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content sharkbet-register__content">
          <button type="button" class="sharkbet-register__close" data-bs-dismiss="modal" aria-label="Cerrar">
            <i class="fas fa-times" aria-hidden="true"></i>
          </button>

          <div v-if="submitted" class="sharkbet-register__success">
            <i class="fas fa-check-circle" aria-hidden="true"></i>
            <h2>Registro completado</h2>
            <p>Tu cuenta fue creada correctamente. Ya puedes iniciar sesion.</p>
            <button type="button" data-bs-dismiss="modal" @click="resetForm">Cerrar</button>
          </div>

          <form v-else @submit.prevent="register">
            <header class="sharkbet-register__header">
              <span class="sharkbet-register__mark" aria-hidden="true"></span>
              <h2 id="sharkbetRegisterTitle">REGISTRO</h2>
            </header>
            <p class="sharkbet-register__required-note">Todos los campos con asterisco (*) son requeridos</p>
            <div v-if="status.message" class="sharkbet-register__alert" role="alert">{{ status.message }}</div>

            <section class="sharkbet-register__grid">
              <label class="sharkbet-register__field">
                <span>Correo electronico *</span>
                <i class="fas fa-envelope" aria-hidden="true"></i>
                <input v-model.trim="form.email" type="email" autocomplete="email" required>
              </label>
              <label class="sharkbet-register__field">
                <span>Nombre de usuario *</span>
                <i class="fas fa-user" aria-hidden="true"></i>
                <input v-model.trim="form.username" type="text" minlength="5" autocomplete="username" required
                  @keydown.space.prevent>
              </label>
              <label class="sharkbet-register__field">
                <span>Contrasena *</span>
                <i class="fas fa-lock" aria-hidden="true"></i>
                <input v-model="form.password" :type="showPassword ? 'text' : 'password'" minlength="6"
                  autocomplete="new-password" required>
                <button type="button" :aria-label="showPassword ? 'Ocultar contrasena' : 'Mostrar contrasena'"
                  @click="showPassword = !showPassword"><i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i></button>
              </label>
              <label class="sharkbet-register__field">
                <span>Repetir contrasena *</span>
                <i class="fas fa-lock" aria-hidden="true"></i>
                <input v-model="form.passwordConfirmation" :type="showPasswordConfirmation ? 'text' : 'password'"
                  minlength="6" autocomplete="new-password" required>
                <button type="button" :aria-label="showPasswordConfirmation ? 'Ocultar contrasena' : 'Mostrar contrasena'"
                  @click="showPasswordConfirmation = !showPasswordConfirmation"><i :class="showPasswordConfirmation ? 'fas fa-eye-slash' : 'fas fa-eye'"></i></button>
              </label>
            </section>

            <hr>

            <section class="sharkbet-register__grid">
              <label class="sharkbet-register__field">
                <span>Primer nombre *</span>
                <i class="fas fa-user" aria-hidden="true"></i>
                <input v-model.trim="form.firstname" type="text" autocomplete="given-name" required>
              </label>
              <label class="sharkbet-register__field">
                <span>Apellido *</span>
                <i class="fas fa-user" aria-hidden="true"></i>
                <input v-model.trim="form.lastname" type="text" autocomplete="family-name" required>
              </label>
              <label class="sharkbet-register__field">
                <span>Fecha de nacimiento *</span>
                <i class="fas fa-calendar-alt" aria-hidden="true"></i>
                <input v-model="form.birthday" type="date" required>
              </label>
              <label class="sharkbet-register__field">
                <span>Documento de identidad *</span>
                <i class="fas fa-id-card" aria-hidden="true"></i>
                <input v-model.trim="form.dni" type="text" required>
              </label>
              <label class="sharkbet-register__field">
                <span>Pais *</span>
                <i class="fas fa-flag" aria-hidden="true"></i>
                <select v-model="form.country" required>
                  <option v-for="country in countries" :key="country.code" :value="country.code">{{ countryName(country) }}</option>
                </select>
              </label>
              <label class="sharkbet-register__field">
                <span>Ciudad *</span>
                <i class="fas fa-city" aria-hidden="true"></i>
                <input v-model.trim="form.city" type="text" autocomplete="address-level2" required>
              </label>
              <label class="sharkbet-register__field">
                <span>Direccion *</span>
                <i class="fas fa-home" aria-hidden="true"></i>
                <input v-model.trim="form.address" type="text" autocomplete="street-address" required>
              </label>
              <label class="sharkbet-register__field">
                <span>Codigo postal *</span>
                <i class="fas fa-map-marker-alt" aria-hidden="true"></i>
                <input v-model.trim="form.postal_code" type="text" autocomplete="postal-code" required>
              </label>
              <label class="sharkbet-register__field">
                <span>Numero de telefono *</span>
                <span class="sharkbet-register__phone-code">{{ phoneCode }}</span>
                <input v-model.trim="form.phone" class="sharkbet-register__phone" type="tel" inputmode="numeric"
                  pattern="[0-9]{7,15}" autocomplete="tel-national" required>
              </label>
              <label class="sharkbet-register__field">
                <span>Moneda *</span>
                <i class="fas fa-coins" aria-hidden="true"></i>
                <select v-model="form.currency" required>
                  <option v-for="currency in currencies" :key="currency" :value="currency">{{ currency }}</option>
                </select>
              </label>
              <label class="sharkbet-register__field sharkbet-register__field--agent">
                <span>ID del agente *</span>
                <i class="fas fa-user-tie" aria-hidden="true"></i>
                <input v-model.trim="form.agentId" type="text" inputmode="numeric" pattern="[1-9][0-9]*" required>
              </label>
            </section>

            <hr>

            <section class="sharkbet-register__checks">
              <label><input v-model="form.acceptTerms" type="checkbox" required><span>Tengo mas de 18 y acepto los <button type="button" @click="terms">Terms and Conditions</button> y <button type="button" @click="terms">Privacy Policy Terms</button> *</span></label>
              <label><input v-model="form.receiveNews" type="checkbox"><span>Quiero recibir novedades por email</span></label>
            </section>

            <button class="sharkbet-register__submit" type="submit" :disabled="registering">
              {{ registering ? 'Registrando...' : 'Registrarse' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
const countriesData = require('../../../assets/countries.json');

export default {
  name: 'SharkbetRegister',
  props: ['skin', 'translation', 'language'],
  data() {
    return {
      showPassword: false,
      showPasswordConfirmation: false,
      registering: false,
      submitted: false,
      status: { message: '' },
      form: this.emptyForm(),
    };
  },
  computed: {
    apiUrlnew() {
      return this.$store.getters['getApiUrlnew'];
    },
    countries() {
      return countriesData.countries.slice().sort((a, b) => this.countryName(a).localeCompare(this.countryName(b), this.language));
    },
    currencies() {
      return [...new Set(countriesData.countries.map(country => country.currency).filter(Boolean))].sort();
    },
    phoneCode() {
      const country = this.countries.find(country => country.code === this.form.country);
      return country?.dial_code || '';
    },
  },
  methods: {
    emptyForm() {
      return {
        email: '',
        username: '',
        password: '',
        passwordConfirmation: '',
        firstname: '',
        lastname: '',
        birthday: '',
        dni: '',
        country: this.skin?.register_fields?.default_country || 'AR',
        city: '',
        address: '',
        postal_code: '',
        phone: '',
        currency: this.skin?.register_fields?.default_currency || 'ARS',
        agentId: '',
        acceptTerms: false,
        receiveNews: false,
      };
    },
    countryName(country) {
      return this.language === 'es' ? country.name_es : country.name_en;
    },
    async register() {
      this.status.message = '';

      if (this.form.password !== this.form.passwordConfirmation) {
        this.status.message = 'Las contrasenas no coinciden.';
        return;
      }
      if (!this.isAdult(this.form.birthday)) {
        this.status.message = 'Debes ser mayor de 18 anos para registrarte.';
        return;
      }
      if (!/^[1-9]\d*$/.test(this.form.agentId)) {
        this.status.message = 'Ingresa un ID de agente valido.';
        return;
      }

      this.registering = true;
      try {
        // Only fields supported by user/register are sent. Address details remain local to this form.
        const data = {
          country: this.form.country,
          username: this.form.username,
          email: this.form.email,
          firstname: this.form.firstname,
          lastname: this.form.lastname,
          password: this.form.password,
          phone: `${this.phoneCode}${this.form.phone}`,
          dni: this.form.dni,
          root: Number(this.form.agentId),
        };
        const response = await axios.post(`${this.apiUrlnew}user/register`, data);

        if (response.data?.error) {
          this.status.message = response.data.message || response.data.error;
          return;
        }
        this.submitted = true;
      } catch (error) {
        let msg = error.response?.data?.message || error.response?.data?.error || '';
        const lowerMsg = msg.toLowerCase();
        if (lowerMsg.includes('root invalido') || lowerMsg.includes('root inválido')) {
          this.status.message = 'El ID de agente ingresado no es válido. Verifica e intenta de nuevo.';
        } else {
          this.status.message = msg || 'No fue posible completar el registro. Intentalo de nuevo.';
        }
      } finally {
        this.registering = false;
      }
    },
    terms() {
      const language = this.language === 'en' ? 'eng' : this.language === 'pt' ? 'pt-br' : 'spa';
      const site = this.$store.getters['getUserData']?.site || '';
      window.open(`https://docs.sistemasw3.com/terms/${language}/?site=${site.toUpperCase()}&link=${site}`, '_blank');
    },
    isAdult(birthday) {
      const birthDate = new Date(`${birthday}T00:00:00`);
      const today = new Date();
      const adultDate = new Date(birthDate.getFullYear() + 18, birthDate.getMonth(), birthDate.getDate());
      return !Number.isNaN(birthDate.getTime()) && adultDate <= today;
    },
    resetForm() {
      this.form = this.emptyForm();
      this.status.message = '';
      this.submitted = false;
      this.showPassword = false;
      this.showPasswordConfirmation = false;
    },
  },
};
</script>

<style scoped>
.sharkbet-register__modal { background: rgba(0, 18, 70, .78); }
.sharkbet-register__content { background: #fff; border: 0; border-radius: 0; color: #14233a; margin: 0 auto; max-width: 900px; padding: 38px 32px 18px; position: relative; }
.sharkbet-register__close { background: transparent; border: 0; color: #647080; font-size: 20px; padding: 6px; position: absolute; right: 14px; top: 10px; }
.sharkbet-register__header { align-items: center; display: flex; gap: 10px; margin-bottom: 28px; }
.sharkbet-register__header h2 { font-size: 26px; font-weight: 400; margin: 0; }
.sharkbet-register__mark { background: linear-gradient(105deg, #009bd3 0 26%, #d2edfa 26% 100%); display: block; height: 34px; transform: skewX(-12deg); width: 47px; }
.sharkbet-register__required-note { font-size: 14px; margin-bottom: 16px; }
.sharkbet-register__alert { background: #fce3e4; border: 1px solid #df7178; border-radius: 4px; color: #9e2630; margin-bottom: 16px; padding: 10px 12px; }
.sharkbet-register__grid { display: grid; gap: 12px; grid-template-columns: repeat(2, minmax(0, 1fr)); }
.sharkbet-register__field { display: grid; font-size: 14px; gap: 5px; position: relative; }
.sharkbet-register__field > span { font-weight: 500; }
.sharkbet-register__field > i { color: #7c858c; font-size: 15px; left: 13px; position: absolute; top: 32px; }
.sharkbet-register__phone-code { color: #66717a; font-size: 13px; left: 13px; position: absolute; top: 32px; }
.sharkbet-register__field input, .sharkbet-register__field select { border: 1px solid #c9cdd1; border-radius: 20px; color: #17212a; height: 33px; outline-color: #009bd3; padding: 0 38px; width: 100%; }
.sharkbet-register__field input.sharkbet-register__phone { padding-left: 46px; }
.sharkbet-register__field select { appearance: auto; padding-right: 12px; }
.sharkbet-register__field button { background: transparent; border: 0; color: #7c858c; padding: 0 11px; position: absolute; right: 0; top: 28px; }
.sharkbet-register__field--agent { grid-column: 1; }
.sharkbet-register hr { border: 0; border-top: 1px solid #d8d8d8; margin: 26px 0 12px; }
.sharkbet-register__checks { display: grid; gap: 12px; margin-bottom: 24px; }
.sharkbet-register__checks label { align-items: flex-start; display: flex; font-size: 14px; gap: 9px; }
.sharkbet-register__checks input { accent-color: #009bd3; height: 15px; margin-top: 2px; width: 15px; }
.sharkbet-register__checks button { background: transparent; border: 0; color: #2b6eb0; padding: 0; text-decoration: underline; }
.sharkbet-register__submit, .sharkbet-register__success button { background: #049cd4; border: 0; border-radius: 22px; color: #fff; font-weight: 600; height: 34px; width: 100%; }
.sharkbet-register__submit:disabled { cursor: not-allowed; opacity: .65; }
.sharkbet-register__success { align-items: center; display: flex; flex-direction: column; gap: 14px; min-height: 280px; justify-content: center; text-align: center; }
.sharkbet-register__success > i { color: #18a965; font-size: 54px; }
.sharkbet-register__success h2, .sharkbet-register__success p { margin: 0; }
.sharkbet-register__success button { max-width: 260px; }
@media (max-width: 767px) {
  .sharkbet-register__content { min-height: 100vh; padding: 34px 20px 20px; }
  .sharkbet-register__grid { grid-template-columns: 1fr; }
  .sharkbet-register__field--agent { grid-column: auto; }
}
</style>
